import classnames from 'classnames';
import { useRef, useEffect, useState } from 'react';
import { useConfig } from '@common/Hooks/useConfig';
import { prepareTrackingDataAttributes } from '@common/Listing/helpers/tracking';
import { SponsoredProductsCard } from '@common/Product/Sponsor/SponsoredProductsCard';
import ProductCardRedesign from '@common/ProductCard/containers/ProductCardRedesign';
import { isFeatureActive } from '@helpers/index';

export function MyListsCard(props) {
    const config = useConfig();
    const isRelatedSponsoredProducts = isFeatureActive('PLT-88556-podium-fe-add-sponsored-tag-for-pdp-related-products', config);
    const containerRef = useRef(null);
    const {
        containerClassName,
        trackingValues,
        imageSizes,
        children,
        navigationId,
        product,
        ...cardProps
    } = props;
    const [elementWidth, setElementWidth] = useState(0);
    const { bmp } = trackingValues;
    const { productCardImageDimensions } = config;
    const bmpTrackingValues = {
        ...bmp,
        elementOffsetWidth: elementWidth
    };
    const dataAttributes = prepareTrackingDataAttributes({
        product,
        ...(navigationId && { navigationId })
    });

    useEffect(() => {
        setElementWidth(containerRef.current?.offsetWidth);
    }, []);

    return (
        <li
            ref={containerRef}
            className={classnames('impression-product', containerClassName)}
            {...dataAttributes}
        >
            {(product.sponsored_product_tracking && isRelatedSponsoredProducts)
                ? (
                    <SponsoredProductsCard
                        key={product.variants[0].id}
                        product={product}
                        trackingValues={{
                            ...trackingValues,
                            bmp: bmpTrackingValues
                        }}
                    />
                )
                : (
                    <ProductCardRedesign
                        imageSizes={imageSizes ?? { dimension: productCardImageDimensions.small }}
                        product={product}
                        trackingValues={{
                            ...trackingValues,
                            bmp: bmpTrackingValues
                        }}
                        {...cardProps}
                        lazyLoad
                    />
                )}
            {children}
        </li>
    );
}
